import Slideable from "../classes/slideable";

export default function InitSitemap() {
    const sitemapToggle = document.querySelector('#sitemap-toggle');

    if (!sitemapToggle)
        return;

    const sitemapToggleSvg = sitemapToggle.querySelector('svg');
    const siteMap = document.querySelector('#sitemap');
    const rotationClass = 'rotate-180';
    var sitemapSlidable = new Slideable(siteMap);
    sitemapToggle.addEventListener('click', (event) => {
        event.preventDefault();
        sitemapSlidable.toggle();
        if (sitemapToggleSvg.classList.contains(rotationClass))
            sitemapToggleSvg.classList.remove(rotationClass)
        else sitemapToggleSvg.classList.add(rotationClass);
    });
}